import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.sync()
  }

  sync() {
    const byCategory = {}

    this.checkboxTargets.forEach((checkbox) => {
      const categoryId = checkbox.dataset.categoryId
      if (!categoryId) return

      if (!byCategory[categoryId]) byCategory[categoryId] = []
      byCategory[categoryId].push(checkbox)
    })

    Object.values(byCategory).forEach((group) => {
      const checked = group.find((checkbox) => checkbox.checked)

      group.forEach((checkbox) => {
        checkbox.disabled = Boolean(checked && checked !== checkbox)
      })
    })
  }
}
